import { ImportFolders } from "src/core/components/import/ImportFolders";

export const Import = () => <ImportFolders />;
